export const SCORE_TYPES = {
  COURSE_COMPLETION: 1, // rank based on course progress
  EXAMS: 2, // rank based on total score
  COMBINED: 3, // rank based on course progress and total score
};
